import axios from "axios";
import { createActionErrorCapture, errorEnvelope } from '../../../../utils/sentryUtils';
import { profilerLanguageUrl, profilerUrl } from "../urls";
import { getTokenHeader, getToken } from "../../../Common/Token";


const captureActionError = createActionErrorCapture('profiler');
const normalizeEmptyToNull = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => normalizeEmptyToNull(item));
  }

  if (value && typeof value === "object") {
    return Object.keys(value).reduce((acc, key) => {
      acc[key] = normalizeEmptyToNull(value[key]);
      return acc;
    }, {});
  }

  if (value === undefined || (typeof value === "string" && value.trim() === "")) {
    return null;
  }

  return value;
};

export const getProfilerAction = async () => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.get(profilerUrl(), getTokenHeader(token));
      return next(response.data);
    } catch (err) {
      captureActionError(err, 'getProfilerAction');
      return next(errorEnvelope(err, 'Failed to fetch account details'));
    }
  });
};

export const getModulerProfilerAction = async (module) => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.get(`${profilerUrl()}?module=${module}`, getTokenHeader(token));
      return next(response.data);
    } catch (err) {
      captureActionError(err, 'getModulerProfilerAction', { module });
      return next(errorEnvelope(err, 'Failed to fetch account details'));
    }
  });
};

export const UpdateProfilerAction = async (data) => {
  try {
    const token = await getToken();
    const normalizedData = normalizeEmptyToNull(data);
    const { data: result } = await axios.put(profilerUrl(), normalizedData, getTokenHeader(token));
    return result;
  } catch (err) {
    captureActionError(err, 'UpdateProfilerAction');
    return errorEnvelope(err, 'Something went wrong. Please try again.');
  }
};
export const SendProfilerAction = async (data) => {
  try {
    const token = await getToken();
    const normalizedData = normalizeEmptyToNull(data);
    const { data: result } = await axios.post(profilerUrl(), normalizedData, getTokenHeader(token));
    return result;
  } catch (err) {
    captureActionError(err, 'SendProfilerAction');
    return errorEnvelope(err, 'Something went wrong. Please try again.');
  }
};
export const getLanguagesAction = async () => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.get(profilerLanguageUrl(), getTokenHeader(token));
      return next(response.data);
    } catch (err) {
      captureActionError(err, 'getLanguagesAction');
      return next(errorEnvelope(err, 'Failed to fetch languages'));
    }
  });
};
